export const toRegex = (input: Array<string>, flags?: string): RegExp => {
  const pattern = input
    .join('|')
    .split('|')
    .filter((value, idx, lst) => lst.indexOf(value) === idx)
    .join('|')
    .replace(/\*/gim, '\\*')
    .replace(/\+/gim, '\\+')
    .replace(/\//gim, '\\/')
    .replace(/\s+/gim, '(\\s+)');

  // console.log(`toRegex(${input.join()}) -> ${pattern}`)

  // NB:
  // we notice test method is not working as expected
  // use isTruthy(xx.match(regex)?.length) instead
  return new RegExp(pattern, flags ?? 'gim');
};
